import { formatUrl } from 'next/dist/shared/lib/router/utils/format-url';
import { allQueryParamsFalsy } from 'helpers/allQueryParamsFalsy';
import { buildHref } from 'helpers/buildHref';
import { FilterableQueryParams } from 'models/FilterableQueryParams';
import { UrlObject } from 'url';

/*
We build the canonical link's href attribute based on the category and other
query parameters.

It would have been easy to just use next/link, which would have automatically
added the host, the locale, etc.

Alas, all elements inside next/head need to be contained as direct children
of the Head element (...), otherwise the tags won't be correctly picked up
on client-side navigations (https://nextjs.org/docs/api-reference/next/head)

Therefore, we can't use next/link and need to rebuild parts of next/link
ourselves.
*/
export function buildCanonicalHref(
  activeFilters: FilterableQueryParams,
  urlObject: UrlObject
): string {
  const categoryMustBeRemoved = activeFilters.account && activeFilters.category;
  const canonicalLinkPage =
    allQueryParamsFalsy({
      ...activeFilters,
      page: undefined
    }) && !categoryMustBeRemoved
      ? activeFilters.page
      : undefined;

  const baseUrlObject = buildHref({
    category: categoryMustBeRemoved ? undefined : activeFilters.category,
    keyword: activeFilters.keyword,
    account: activeFilters.account,
    page: canonicalLinkPage
  });

  return formatUrl({
    ...baseUrlObject,
    ...urlObject
  });
}
